import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import RemainingLandingContent from './RemainingLandingContent';

const WhatsappChatbot = () => (
  <>
    <Helmet>
      <title>WhatsApp Chatbot for Customer Support | HAWKTRION</title>
      <meta name="description" content="Build a WhatsApp chatbot to answer common questions, qualify leads, support customers, and hand conversations to your team when needed." />
      <meta name="keywords" content="WhatsApp chatbot, WhatsApp customer support chatbot, WhatsApp chatbot automation" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-chatbot/" />
      <meta property="og:title" content="WhatsApp Chatbot for Customer Support | HAWKTRION" />
      <meta property="og:description" content="Build a WhatsApp chatbot to answer common questions, qualify leads, support customers, and hand conversations to your team when needed." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-chatbot/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp Chatbot for Customer Support | HAWKTRION" />
      <meta name="twitter:description" content="Build a WhatsApp chatbot to answer common questions, qualify leads, support customers, and hand conversations to your team when needed." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp Chatbot for Customer Support and Automation" hideCta>
      <RemainingLandingContent pageKey="chatbot" />
    </SeoLandingPage>
  </>
);

export default WhatsappChatbot;